import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
const DieProfileList = lazy(
  () => import('../components/Die Profile/DieProfileList'),
);
import PrivateRoute from './PrivateRoute';

import Login from '../components/Authentication/Login';
import OpenInquiry from '../components/Authentication/OpenInquiry';
import ArchiveBulkOrderList from '../components/Bulk Order List/ArchiveBulkOrderList';
import BulkOrderList from '../components/Bulk Order List/BulkOrderList';
import AddConversionRate from '../components/Coversion Rate/AddConversionRate';
import ConversionRateList from '../components/Coversion Rate/ConversionRateList';
import EditConversionRate from '../components/Coversion Rate/EditConversionRate';
import ViewRateList from '../components/Coversion Rate/ViewRateList';
import PackingList from '../components/Packing/PackingList';
import AddPackingMode from '../components/Packing/AddPackingMode';
import EditPackingMode from '../components/Packing/EditPackingMode';
import ArchivePacking from '../components/Packing/ArchivePacking';
import AddNewCustomer from '../components/Customer/AddNewCustomer';
import ArchiveCustomerList from '../components/Customer/ArchiveCustomerList';
import CustomerList from '../components/Customer/CustomerList';
import EditCustomer from '../components/Customer/EditCustomer';
import ViewCustomer from '../components/Customer/ViewCustomer';
import ArchiveCustomerTypeList from '../components/CustomerType/ArchiveCustomerTypeList';
import CustomerTypeList from '../components/CustomerType/CustomerTypeList';
import Dashboard from '../components/Dashboard/Dashboard';
import AddPress from '../components/Die Press/AddPress';
import EditPress from '../components/Die Press/EditPress';
import AddDieProfile from '../components/Die Profile/AddDieProfile';
import AddProfileDieTool from '../components/Die Profile/AddProfileDieTool';
import EditDieProfile from '../components/Die Profile/EditDieProfile';
import ViewDieProfile from '../components/Die Profile/ViewDieProfile';
import ArchiveDieSubCategories from '../components/Die SubCategory/ArchiveDieSubCategory';
import DieSubCategoryList from '../components/Die SubCategory/DieSubCategoryList';
import DieSummarySizeReport from '../components/Die Summary Size Report/DieSummarySizeReport';
import AddDieQuotation from '../components/DieQuotation/AddDieQuotation';
import ArchiveDieQuotationList from '../components/DieQuotation/ArchiveDieQuotationList';
import DieQuotationList from '../components/DieQuotation/DieQuotationList';
import EditDieQuotation from '../components/DieQuotation/EditDieQuotation';
import AddDieTool from '../components/DieTool/AddDieTool';
import DieLifeCard from '../components/DieTool/DieLifeCard';
import DieToolList from '../components/DieTool/DieToolList';
import EditDieTool from '../components/DieTool/EditDieTool';
import DieTypeList from '../components/DieType/DieTypeList';
import NotFoundPage from '../components/NotFoundPage';
import ChangePassword from '../components/Profile/ChangePassword';
import EditProfile from '../components/Profile/Profile';
import Setting from '../components/Setting/Setting';
import ArchiveProformaList from '../components/Proforma/ArchiveProformaList';
import CreateProforma from '../components/Proforma/CreateProforma';
import EditProforma from '../components/Proforma/EditProforma';
import ProformaList from '../components/Proforma/ProformaList';
import ArchiveQuotationList from '../components/Quotation/ArchiveQuotationList';
import CreateQuotation from '../components/Quotation/CreateQuotation';
import EditQuotation from '../components/Quotation/EditQuotation';
import QuotationList from '../components/Quotation/QuotationList';
import TemperList from '../components/Tempers/TemperList';
import ArchiveTemperList from '../components/Tempers/ArchiveTemperList';
const AddEditTemper = lazy(() => import('../components/Tempers/AddEditTemper'));
const ViewTemper = lazy(() => import('../components/Tempers/ViewTemper'));
const ViewArchiveTemper = lazy(() => import('../components/Tempers/ViewArchiveTemper'));
import AddVendor from '../components/Vendor/AddVendor';
import VendorList from '../components/Vendor/VendorList';
import ArchiveWorkOrderList from '../components/Work Order/ArchiveWorkOrderList';
import CreateWorkOrder from '../components/Work Order/CreateWorkOrder';
import EditWorkOrder from '../components/Work Order/EditWorkOrder';
import WorkOrderList from '../components/Work Order/WorkOrderList';
import WareHouseBundleForOutWard from '../components/WareHouse/WareHouseBundleForOutWard';

import AddWarehouseBundleOutWard from '../components/WareHouse/AddWareHouseBundleOutWard';
import WorkOrderFilterList from '../components/Work Order/WorkOrderFilterList';

import ArchiveDieCategories from '../components/Die Categories/ArchiveDieCategories';
import ArchiveDieProfile from '../components/Die Profile/ArchiveDieProfile';
import ArchiveDieTool from '../components/DieTool/ArchiveDieTool';
import ArchiveDieType from '../components/DieType/ArchiveDieType';
import PlantTypeList from '../components/Plant Type/PlantTypeList';
import ArchivePlantTypeList from '../components/Plant Type/ArchivePlantTypeList';
const ViewArchivePlantType = lazy(() => import('../components/Plant Type/ViewArchivePlantType'));
const PlantList = lazy(() => import('../components/Plant/PlantList'));
const ArchivePlantList = lazy(() => import('../components/Plant/ArchivePlantList'));
const ViewArchivePlant = lazy(() => import('../components/Plant/ViewArchivePlant'));
const DepartmentList = lazy(() => import('../components/Department/DepartmentList'));
const ArchiveDepartmentList = lazy(() => import('../components/Department/ArchiveDepartmentList'));
const ViewDepartment = lazy(() => import('../components/Department/ViewDepartment'));
const ViewArchiveDepartment = lazy(() => import('../components/Department/ViewArchiveDepartment'));
const ItemCategoryList = lazy(() => import('../components/Item Category/ItemCategoryList'));
const ArchiveItemCategoryList = lazy(() => import('../components/Item Category/ArchiveItemCategoryList'));
const ViewItemCategory = lazy(() => import('../components/Item Category/ViewItemCategory'));
const ViewArchiveItemCategory = lazy(() => import('../components/Item Category/ViewArchiveItemCategory'));
const AlloyList = lazy(() => import('../components/Alloys/AlloyList'));
const ArchiveAlloyList = lazy(() => import('../components/Alloys/ArchiveAlloyList'));
const AddEditAlloy = lazy(() => import('../components/Alloys/AddEditAlloy'));
const ViewAlloy = lazy(() => import('../components/Alloys/ViewAlloy'));
const ViewArchiveAlloy = lazy(() => import('../components/Alloys/ViewArchiveAlloy'));
const StoreList = lazy(() => import('../components/Stores/StoreList'));
const ArchiveStoreList = lazy(() => import('../components/Stores/ArchiveStoreList'));
const DieGroupList = lazy(() => import('../components/Die Group/DieGroupList'));
const ArchiveDieGroupList = lazy(() => import('../components/Die Group/ArchiveDieGroupList'));
const DieCategoryList = lazy(() => import('../components/Die Categories/DieCategoryList'));
const ArchiveDieCategoryList = lazy(() => import('../components/Die Categories/ArchiveDieCategoryList'));
const DieSizeList = lazy(() => import('../components/Die Size/DieSizeList'));
const ArchiveDieSizeList = lazy(() => import('../components/Die Size/ArchiveDieSizeList'));
const DiePressList = lazy(() => import('../components/Die Press/DiePressList'));
const ArchiveDiePressList = lazy(() => import('../components/Die Press/ArchiveDiePressList'));
const PackingModeList = lazy(() => import('../components/Packing Mode/PackingModeList'));
const ArchivePackingModeList = lazy(() => import('../components/Packing Mode/ArchivePackingModeList'));

import ForgetPassword from '../components/Authentication/ForgetPassword';
import AddBolster from '../components/Bolster/AddBolster';
import ArchiveBolster from '../components/Bolster/ArchiveBolster';
import Bolster from '../components/Bolster/Bolster';
import EditBolster from '../components/Bolster/EditBolster';
import AddBundleInWard from '../components/BundleInWard/AddBundleInWard';
import ArchiveBundleInWard from '../components/BundleInWard/ArchiveBundleInWard';
import BundleInWardList from '../components/BundleInWard/BundleInWardList';
import PartyPrintAddInWard from '../components/BundleInWard/PartyPrintAddInWard';
import PrintAddBundleInWard from '../components/BundleInWard/PrintAddBundleInWard';
import PrintBundleInWard from '../components/BundleInWard/PrintBundleInWard';
import AddBundleForOutWard from '../components/BundleOutWard/AddBundleForOutWard';
import AddBundleOutWard from '../components/BundleOutWard/AddBundleOutWard';
import ArchiveBundleOutWard from '../components/BundleOutWard/ArchiveBundleOutWard';
import BundleOutWardList from '../components/BundleOutWard/BundleOutWardList';
import PartyPrintAddBundleForOutWard from '../components/BundleOutWard/PartyPrintAddBundleForOutWard';
import PrintForAddBundleForOutWard from '../components/BundleOutWard/PrintForAddBundleForOutWard';
import ArchiveConversionRateList from '../components/Coversion Rate/ArchiveConversionRateList';
import ArchiveCurrentStockData from '../components/Current Stock/ArchiveCurrentStockData';
import CurrentStockData from '../components/Current Stock/CurrentStockData';
import CurrentStockList from '../components/Current Stock/CurrentStockList';
import ViewDieQuotationList from '../components/DieQuotation/ViewDieQuotationList';
import DispatchVerificationList from '../components/Dispatch Verification/DispatchVerificationList';
import ArchiveExcessStock from '../components/Excess Stock/ArchiveExcessStock';
import CreateExcessStock from '../components/Excess Stock/CreateExcessStock';
import ExcessStockList from '../components/Excess Stock/ExcessStockList';
import IndentStatus from '../components/IndentStatus/IndentStatus';
import AddUser from '../components/ManageUser/AddUser';
import ArchiveUserList from '../components/ManageUser/ArchiveUserList';
import EditUser from '../components/ManageUser/EditUser';
import ViewUser from '../components/ManageUser/ViewUser';
import ArchiveNalco from '../components/Nalco/ArchiveNalco';
import Nalco from '../components/Nalco/Nalco';
import ArchivePlanningList from '../components/Planning/ArchivePlanningList';
import CreatePlanning from '../components/Planning/CreatePlanning';
import EditPlanning from '../components/Planning/EditPlanning';
import PlanningList from '../components/Planning/PlanningList';
import ViewProforma from '../components/Proforma/ViewProforma';
import ViewQuotationList from '../components/Quotation/ViewQuotationList';
import PrintQuotation from '../components/Authentication/PrintQuotation';
import AddNewReport from '../components/Stock Verification/AddNewReport';
import StockVerificationList from '../components/Stock Verification/StockVerificationList';
import ArchiveVendor from '../components/Vendor/ArchiveVendor';
import EditVendor from '../components/Vendor/EditVendor';
import ViewVendor from '../components/Vendor/ViewVendor';
import WareHouseBundleOutWard from '../components/WareHouse/WareHouseBundleOutWard';
import WareHouseCurrentStock from '../components/WareHouse/WareHouseCurrentStock';
import WareHouseCurrentStockDetails from '../components/WareHouse/WareHouseCurrentStockDetails';
import ViewWorkOrderList from '../components/Work Order/ViewWorkOrderList';
import PrintWorkOrder from '../components/Authentication/PrintWorkOrder';
import PrintProforma from '../components/Authentication/PrintProforma';

import WorkOrderReport from '../components/Work Order/WorkOrderReport';
import AddUserGroup from './../components/ManageUser/AddUserGroup';
import ArchiveUserGroupList from './../components/ManageUser/ArchiveUserGroupList';
import EditUserGroup from './../components/ManageUser/EditUserGroup';
import ManageUser from './../components/ManageUser/ManageUser';
import ManageUserGroup from './../components/ManageUser/ManageUserGroup';
import ViewUserGroup from './../components/ManageUser/ViewUserGroup';

import ConvertToWorkOrder from '../components/Quotation/ConvertToWorkOrder';
import PrintExcessStock from '../components/Excess Stock/PrintExcessStock';
import FinalizeBundleOutward from '../components/BundleOutWard/FinalizeBundleOutward';
import PrintDiequotation from '../components/Authentication/PrintDiequotation';
import PrintBundleOutWard from '../components/BundleOutWard/PrintBundleOutWard';
import EditBundleOutWard from '../components/BundleOutWard/EditBundleOutWard';
import DraftPrintBundleOutWard from '../components/BundleOutWard/DraftPrintBundleOutWard';
import EditWareHouseBundleOutWard from '../components/WareHouse/EditWareHouseBundleOutWard';

import FinalizeWarehouseBundleOutward from '../components/WareHouse/FinalizeWarehouseBundleOutward';
import WarehousePrintBundleOutWard from '../components/WareHouse/WarehousePrintBundleOutWard';
import WarehouseDraftPrintBundleOutWard from '../components/WareHouse/WarehouseDraftPrintBundleOutWard';
import EditReport from '../components/Stock Verification/EditReport';
import PrintStcokVerification from '../components/Authentication/PrintStcokVerification';
import PriorityList from '../components/Planning/PriorityList';
import PrintQuotation2 from '../components/Authentication/PrintQuotation2';
import PrintQuotation3 from '../components/Authentication/PrintQuotation3';

import PrintDiequotation2 from '../components/Authentication/PrintDiequotation2';
import PrintDiequotation3 from '../components/Authentication/PrintDiequotation3';
import PrintWorkOrder2 from '../components/Authentication/PrintWorkOrder2';
import PrintWorkOrder3 from '../components/Authentication/PrintWorkOrder3';
import PrintWorkOrderFull from '../components/Authentication/PrintWorkOrderFull';
import ProductionList from '../components/Production/ProductionList';
import CreateProduction from '../components/Production/CreateProductionList';
import EditProduction from '../components/Production/EditProduction';
import ActivityList from '../components/ActivityLog/ActivityList';
import PrintWorkOrderReport from '../components/Die Profile/PrintWorkOrderReport';
import PrintCustomerWorkOrderReport from '../components/Work Order/PrintCustomerWorkOrderReport';
import ViewConversionRate from '../components/Coversion Rate/ViewConversionRate';
import PackingReport from '../components/Report/PackingDatawise/packingReport';
import PackingReportList from '../components/Report/PackingReport/PackingReportList';
import DispatchReport from '../components/Report/Disptach/DispatchReport';
import WorkOrderDateWiseReport from '../components/Report/WorkOrder/WorkOrderDateWiseReport';
// import CustomerInquiryForm from '../components/Customer/CustormerInquiryForm';
import TransporterList from '../components/Transporter/TransporterList';
import ArchiveTransporter from '../components/Transporter/ArchiveTransporter';
import AddTransporter from '../components/Transporter/AddTransporter';
import EditTransporter from '../components/Transporter/EditTransporter';
import InquiryList from '../components/Crm/Inquiry/InquiryList';
import AddNewInquiry from '../components/Crm/Inquiry/AddNewInquiry';
import EditInquiry from '../components/Crm/Inquiry/EditInquiry';
import ViewInquiry from '../components/Crm/Inquiry/ViewInquiry';
import ConvertToQuotation from '../components/Crm/Inquiry/ConvertToQuotation';
import ArchiveInquiryList from "../components/Crm/Inquiry/ArchiveInquiryList";
import InquiryQuotationList from '../components/Crm/Quotation/InquiryQuotationList';
import ArchiveInquiryQuotationList from '../components/Crm/Quotation/ArchiveInquiryQuotationList';
import PrintInquiryQuotation from '../components/Authentication/PrintInquiryQuotation';
import PrintSalesOrder from '../components/Authentication/PrintSalesOrder';
import CreateInquiryQuotation from '../components/Crm/Quotation/CreateInquiryQuotation';
import EditInquiryQuotation from '../components/Crm/Quotation/EditInquiryQuotation';
import ViewInquiryQuotation from '../components/Crm/Quotation/ViewInquiryQuotation';
import ConvertToSalesOrder from '../components/Crm/Quotation/ConvertToSalesOrder';
import SalesOrderList from '../components/Crm/SalesOrders/SalesOrderList';
import CreateSalesOrder from '../components/Crm/SalesOrders/CreateSalesOrder';
import EditSalesOrder from '../components/Crm/SalesOrders/EditSalesOrder';
import ViewSalesOrder from '../components/Crm/SalesOrders/ViewSalesOrder';
import ArchiveSalesOrderList from '../components/Crm/SalesOrders/ArchiveSalesOrderList';
import ConvertSalesToWorkOrder from '../components/Crm/SalesOrders/ConvertSalesToWorkOrder';
import VehicleTypeList from '../components/Vehicle Type/VehicleTypeList';
import ArchiveVehicleTypeList from '../components/Vehicle Type/ArchiveVehicleTypeList';
import MaterialList from '../components/Material Master/MaterialList';
import ArchiveMaterialList from '../components/Material Master/ArchiveMaterialList';
import VehicleList from '../components/Vehicle Master/VehicleList';
import ArchiveVehicleList from '../components/Vehicle Master/ArchiveVehicleList';
import EditFirstWeightEntry from '../components/First Weight Entry/EditFirstWeightEntry';
import AddFirstWeightEntry from '../components/First Weight Entry/AddFirstWeightEntry';
import ArchiveFirstWeightEntry from '../components/First Weight Entry/ArchiveFirstWeightEntry';
import FirstWeightEntryList from '../components/First Weight Entry/FirstWeightEntryList';
import ArchiveSecondWeightEntry from '../components/Second Weight Entry/ArchiveSecondWeightEntry';
import AddSecondWeightEntry from '../components/Second Weight Entry/AddSecondWeightEntry';
import EditSecondWeightEntry from '../components/Second Weight Entry/EditSecondWeightEntry';
import SecondWeightEntryList from '../components/Second Weight Entry/SecondWeightEntryList';
import ManualWeightEntryList from '../components/Manual Weight Entry/ManualWeightEntryList';
import ArchiveManualWeightEntry from '../components/Manual Weight Entry/ArchiveManualWeightEntry';
import AddManualWeightEntry from '../components/Manual Weight Entry/AddManualWeightEntry';
import EditManualWeightEntry from '../components/Manual Weight Entry/EditManualWeightEntry';
//import WorkOrderReport from "../components/Report/WorkOrder/WorkOrderReport";

function Root() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
       <Route path="/inquiry" element={<OpenInquiry />} />
      <Route path="/forgot-password" element={<ForgetPassword />} />
      <Route path="/print/:id" element={<PrintBundleInWard />} />
      <Route
        path="/print/stock-verification/:id"
        element={<PrintStcokVerification />}
      />
      <Route
        path="/add-inward-party-print/:id"
        element={<PartyPrintAddInWard />}
      />
      <Route path="/add-inward-print/:id" element={<PrintAddBundleInWard />} />
      <Route
        path="/party-print-for-add-bundle-outward/:id"
        element={<PartyPrintAddBundleForOutWard />}
      />
      <Route
        path="/warehouse-print-bundle-outword/:id"
        element={<WarehousePrintBundleOutWard />}
      />
      <Route
        path="/warehouse-print-draft-bundle-outword/:id"
        element={<WarehouseDraftPrintBundleOutWard />}
      />
      <Route
        path="/print-for-add-bundle-outward/:id"
        element={<PrintForAddBundleForOutWard />}
      />
      <Route path="/print-excess-stock/:id" element={<PrintExcessStock />} />
      <Route path="/print-quotation/:id" element={<PrintQuotation />} />
      <Route path="/print-quotation2/:id" element={<PrintQuotation2 />} />
      <Route path="/print-quotation3/:id" element={<PrintQuotation3 />} />
      <Route path="/print-die-quotation/:id" element={<PrintDiequotation />} />
      <Route path="/print-inquiry-quotation/:id" element={<PrintInquiryQuotation />} />
      <Route path="/print-sales-order/:id" element={<PrintSalesOrder />} />
      <Route
        path="/print-die-quotation2/:id"
        element={<PrintDiequotation2 />}
      />
      <Route
        path="/print-die-quotation3/:id"
        element={<PrintDiequotation3 />}
      />
      <Route
        path="/print-bundle-outword/:id"
        element={<PrintBundleOutWard />}
      />
      <Route
        path="/print-draft-bundle-outword/:id"
        element={<DraftPrintBundleOutWard />}
      />
      <Route path="/print-work-order2/:id" element={<PrintWorkOrder2 />} />
      <Route path="/print-proforma/:id" element={<PrintProforma />} />
      <Route path="/print-work-order3/:id" element={<PrintWorkOrder />} />
      <Route path="/print-work-order/:id" element={<PrintWorkOrder3 />} />
      <Route path="/print-work-order4/:id" element={<PrintWorkOrderFull />} />
      <Route
        path="/print-profile-workorder-report/:id"
        element={<PrintWorkOrderReport />}
      />
      <Route
        path="/print-customer-workorder-report/:id"
        element={<PrintCustomerWorkOrderReport />}
      />
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<EditProfile />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/inquiry-list" element={<InquiryList />} />
        <Route path="/add-inquiry" element={<AddNewInquiry />} />
        <Route path="/edit-inquiry/:id" element={<EditInquiry />} />
        <Route path="/view-inquiry/:id" element={<ViewInquiry />} />
        <Route path="/convert-inquiry-quotation/:id" element={<ConvertToQuotation />} />
        <Route path="/archive-inquiry-list" element={<ArchiveInquiryList />} />
        <Route path="/inquiry-quotation-list" element={<InquiryQuotationList />} />
        <Route path="/archive-inquiry-quotation-list" element={<ArchiveInquiryQuotationList />} />
        <Route path="/add-inquiry-quotation" element={<CreateInquiryQuotation />} />
        <Route path="/edit-inquiry-quotation/:id" element={<EditInquiryQuotation />} />
        <Route path="/view-inquiry-quotation/:id" element={<ViewInquiryQuotation />} />
        <Route path="/create-sales-order-inquiry-quotation/:id" element={<ConvertToSalesOrder />} />
        <Route path="/sales-order-list" element={<SalesOrderList />} />
        <Route path="/add-sales-order" element={<CreateSalesOrder />} />
        <Route path="/edit-sales-order/:id" element={<EditSalesOrder />} />
        <Route path="/view-sales-order/:id" element={<ViewSalesOrder />} />
        <Route path="/archive-sales-order-list" element={<ArchiveSalesOrderList />} />
        <Route path="/create-sales-order-work-order/:id" element={<ConvertSalesToWorkOrder />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/die-profilelist"
          element={
            <Suspense
              fallback={
                <div className="centered-spinner">
                  <Spin size="large" />
                </div>
              }
            >
              <DieProfileList />
            </Suspense>
          }
        />
        <Route path="/archive-die-profile" element={<ArchiveDieProfile />} />
        <Route path="/add-dieprofile" element={<AddDieProfile />} />
        <Route
          path="/add-die-tool-profile/:id"
          element={<AddProfileDieTool />}
        />
        <Route path="/edit-dieprofile/:id" element={<EditDieProfile />} />
        <Route path="/die-tool" element={<DieToolList />} />
        <Route path="/archive-die-tool" element={<ArchiveDieTool />} />
        <Route path="/add-die-tool" element={<AddDieTool />} />
        <Route path="/edit-die-tool/:id" element={<EditDieTool />} />
        <Route path="/die-life-card/:id" element={<DieLifeCard />} />
        <Route path="/view-dieprofile/:id" element={<ViewDieProfile />} />
        <Route
          path="/die-group-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <DieGroupList />
            </Suspense>
          }
        />
        <Route
          path="/archive-die-group-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveDieGroupList />
            </Suspense>
          }
        />
        <Route
          path="/die-category-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <DieCategoryList />
            </Suspense>
          }
        />
        <Route
          path="/archive-die-category-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveDieCategoryList />
            </Suspense>
          }
        />
        <Route path="/bundle-inward" element={<BundleInWardList />} />
        <Route
          path="/archive-bundle-inward"
          element={<ArchiveBundleInWard />}
        />
        <Route path="/print-workorder-report" element={<WorkOrderReport />} />
        <Route path="/bundle-outward" element={<BundleOutWardList />} />
        <Route
          path="/add-bundle-for-outward/:id/:outward_id"
          element={<AddBundleForOutWard />}
        />
        <Route
          path="/finalize-bundle-for-outward/:id/:outward_id"
          element={<FinalizeBundleOutward />}
        />
        <Route path="/archive-outward" element={<ArchiveBundleOutWard />} />
        <Route path="/add-outward" element={<AddBundleOutWard />} />
        <Route path="/edit-outward/:id" element={<EditBundleOutWard />} />
        <Route path="/current-stock/:id" element={<CurrentStockList />} />
        <Route path="/current-stock-data" element={<CurrentStockData />} />
        <Route
          path="/archive-current-stock"
          element={<ArchiveCurrentStockData />}
        />
        <Route path="/create-excess-stock" element={<CreateExcessStock />} />
        <Route path="/excess-stock" element={<ExcessStockList />} />
        <Route path="/archive-excess-stock" element={<ArchiveExcessStock />} />
        <Route path="/stock-verification" element={<StockVerificationList />} />
        <Route path="/edit-report/:id" element={<EditReport />} />
        <Route path="/add-bundle-inward" element={<AddBundleInWard />} />
        <Route path="/add-new-report" element={<AddNewReport />} />
        <Route
          path="/dispatch-verification"
          element={<DispatchVerificationList />}
        />
        <Route
          path="/archive-die-categories"
          element={<ArchiveDieCategories />}
        />
        <Route path="/die-subcategory" element={<DieSubCategoryList />} />
        <Route
          path="/archive-die-subcategories"
          element={<ArchiveDieSubCategories />}
        />
        <Route
          path="/die-summary-size-report"
          element={<DieSummarySizeReport />}
        />
        <Route
          path="/die-size-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <DieSizeList />
            </Suspense>
          }
        />
        <Route
          path="/archive-die-size-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveDieSizeList />
            </Suspense>
          }
        />
        <Route
          path="/die-press-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <DiePressList />
            </Suspense>
          }
        />
        <Route
          path="/archive-die-press-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveDiePressList />
            </Suspense>
          }
        />
        <Route path="/add-press" element={<AddPress />} />
        <Route path="/edit-press/:id" element={<EditPress />} />
        <Route path="/die-type" element={<DieTypeList />} />
        <Route path="/archive-die-type" element={<ArchiveDieType />} />
        <Route path="/vendor-list" element={<VendorList />} />
        <Route path="/add-vendor" element={<AddVendor />} />
        <Route path="/archive-vendor" element={<ArchiveVendor />} />
        <Route path="/view-vendor/:id" element={<ViewVendor />} />
        <Route path="/edit-vendor/:id" element={<EditVendor />} />
        <Route path="/bolster-list" element={<Bolster />} />
        <Route path="/archive-bolster" element={<ArchiveBolster />} />
        <Route path="/add-bolster" element={<AddBolster />} />
        <Route path="/conversion-rate-list" element={<ConversionRateList />} />
        <Route path="/add-conversion-rate" element={<AddConversionRate />} />
        <Route
          path="/view-conversion-rate/:id"
          element={<ViewConversionRate />}
        />
        <Route
          path="/edit-conversion-rate/:id"
          element={<EditConversionRate />}
        />
        <Route
          path="/archive-conversion-rat-list"
          element={<ArchiveConversionRateList />}
        />
        <Route path="/view-conversion-rate-list" element={<ViewRateList />} />
        <Route
          path="/packing-mode-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <PackingModeList />
            </Suspense>
          }
        />
        <Route
          path="/archive-packing-mode-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchivePackingModeList />
            </Suspense>
          }
        />
        <Route path="/packing-mode" element={<PackingList />} />
        <Route path="/add-packing" element={<AddPackingMode />} />
        <Route path="/edit-packing/:id" element={<EditPackingMode />} />
        <Route path="/archive-packing-mode" element={<ArchivePacking />} />
        <Route path="/quotation-list" element={<QuotationList />} />
        <Route
          path="/archive-quotation-list"
          element={<ArchiveQuotationList />}
        />
        <Route path="/create-quotation" element={<CreateQuotation />} />
        <Route path="/edit-quotation/:id" element={<EditQuotation />} />
        <Route
          path="/create-work-order-quotation/:id"
          element={<ConvertToWorkOrder />}
        />
        <Route path="/customer-list" element={<CustomerList />} />
        <Route
          path="/archive-customer-list"
          element={<ArchiveCustomerList />}
        />
        <Route path="/add-new-customer" element={<AddNewCustomer />} />
        <Route path="/edit-customer/:id" element={<EditCustomer />} />
        <Route path="/view-customer/:id" element={<ViewCustomer />} />
        <Route path="/die-quotation-list" element={<DieQuotationList />} />
        <Route
          path="/archive-die-quotation-list"
          element={<ArchiveDieQuotationList />}
        />
        <Route path="/add-die-quotation" element={<AddDieQuotation />} />
        <Route path="/edit-die-quotation/:id" element={<EditDieQuotation />} />
        <Route
          path="/alloy-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <AlloyList />
            </Suspense>
          }
        />
        <Route
          path="/add-alloy"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <AddEditAlloy />
            </Suspense>
          }
        />
        <Route
          path="/edit-alloy/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <AddEditAlloy />
            </Suspense>
          }
        />
        <Route
          path="/view-alloy/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewAlloy />
            </Suspense>
          }
        />
        <Route
          path="/view-archive-alloy/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewArchiveAlloy />
            </Suspense>
          }
        />
        <Route
          path="/store-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <StoreList />
            </Suspense>
          }
        />
        <Route
          path="/temper-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <TemperList />
            </Suspense>
          }
        />
        <Route
          path="/add-temper"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <AddEditTemper />
            </Suspense>
          }
        />
        <Route
          path="/edit-temper/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <AddEditTemper />
            </Suspense>
          }
        />
        <Route
          path="/view-temper/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewTemper />
            </Suspense>
          }
        />
        <Route
          path="/view-archive-temper/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewArchiveTemper />
            </Suspense>
          }
        />
        <Route
          path="/archive-temper-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveTemperList />
            </Suspense>
          }
        />
        <Route path="/plant-type-list" element={<PlantTypeList />} />
        <Route path="/archive-plant-type-list" element={<ArchivePlantTypeList />} />
        <Route
          path="/view-archive-plant-type/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewArchivePlantType />
            </Suspense>
          }
        />
        <Route
          path="/plant-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <PlantList />
            </Suspense>
          }
        />
        <Route
          path="/archive-plant-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchivePlantList />
            </Suspense>
          }
        />
        <Route
          path="/view-archive-plant/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewArchivePlant />
            </Suspense>
          }
        />
        <Route
          path="/department-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <DepartmentList />
            </Suspense>
          }
        />
        <Route
          path="/archive-department-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveDepartmentList />
            </Suspense>
          }
        />
        <Route
          path="/view-department/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewDepartment />
            </Suspense>
          }
        />
        <Route
          path="/view-archive-department/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewArchiveDepartment />
            </Suspense>
          }
        />
        <Route
          path="/item-category-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ItemCategoryList />
            </Suspense>
          }
        />
        <Route
          path="/archive-item-category-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveItemCategoryList />
            </Suspense>
          }
        />
        <Route
          path="/view-item-category/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewItemCategory />
            </Suspense>
          }
        />
        <Route
          path="/view-archive-item-category/:id"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ViewArchiveItemCategory />
            </Suspense>
          }
        />
        <Route
          path="/customer-type-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <CustomerTypeList />
            </Suspense>
          }
        />
        <Route
          path="/archive-customer-type-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveCustomerTypeList />
            </Suspense>
          }
        />
        <Route path="/work-order-list" element={<WorkOrderList />} />
        <Route
          path="/work-order-filter-list"
          element={<WorkOrderFilterList />}
        />
        <Route
          path="/archive-work-order-list"
          element={<ArchiveWorkOrderList />}
        />
        <Route path="/create-work-order" element={<CreateWorkOrder />} />
        <Route path="/edit-work-order/:id" element={<EditWorkOrder />} />
        <Route path="/proforma-list" element={<ProformaList />} />
        <Route
          path="/archive-proforma-list"
          element={<ArchiveProformaList />}
        />
        <Route path="/create-proforma" element={<CreateProforma />} />
        <Route path="/edit-proforma/:id" element={<EditProforma />} />
        <Route path="/bulk-order-list" element={<BulkOrderList />} />
        <Route
          path="/archive-bulk-order-list"
          element={<ArchiveBulkOrderList />}
        />
        <Route path="/manage-user-group" element={<ManageUserGroup />} />
        <Route path="/archive-user-group" element={<ArchiveUserGroupList />} />
        <Route path="/add-user-group" element={<AddUserGroup />} />
        <Route path="/edit-user-group/:id" element={<EditUserGroup />} />
        <Route path="/view-user-group/:id" element={<ViewUserGroup />} />
        <Route
          path="/warehouse-bundle-outward"
          element={<WareHouseBundleOutWard />}
        />
        <Route
          path="/add-warehouse-bundle-outward"
          element={<AddWarehouseBundleOutWard />}
        />
        <Route
          path="/edit-warehouse-bundle-outward/:id"
          element={<EditWareHouseBundleOutWard />}
        />
        <Route
          path="/finalize-warehouse-bundle-for-outward/:id/:outward_id"
          element={<FinalizeWarehouseBundleOutward />}
        />
        <Route
          path="/warehouse-current-stock"
          element={<WareHouseCurrentStock />}
        />
        <Route
          path="/warehouse-current-stock-details/:id"
          element={<WareHouseCurrentStockDetails />}
        />
        <Route
          path="/add-warehouse-bundle-for-outward/:id/:outward_id"
          element={<WareHouseBundleForOutWard />}
        />
        <Route path="/production-list" element={<ProductionList />} />
        <Route path="/create-production" element={<CreateProduction />} />
        <Route path="/edit-production/:id" element={<EditProduction />} />
        <Route path="/planning-list" element={<PlanningList />} />
        <Route path="/Priority-list" element={<PriorityList />} />
        <Route path="/create-planning/:id" element={<CreatePlanning />} />
        <Route path="/edit-planning/:id" element={<EditPlanning />} />
        <Route path="/archive-planning" element={<ArchivePlanningList />} />
        <Route path="/manage-user" element={<ManageUser />} />
        <Route path="/add-user" element={<AddUser />} />
        <Route path="/edit-user/:id" element={<EditUser />} />
        <Route path="/edit-bolster/:id" element={<EditBolster />} />
        <Route path="/view-user/:id" element={<ViewUser />} />
        <Route path="/archive-user" element={<ArchiveUserList />} />
        <Route
          path="/archive-alloy-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveAlloyList />
            </Suspense>
          }
        />
        <Route
          path="/archive-store-list"
          element={
            <Suspense fallback={<Spin size="large" />}>
              <ArchiveStoreList />
            </Suspense>
          }
        />
        <Route
          path="/view-quotation-list/:id"
          element={<ViewQuotationList />}
        />
        <Route
          path="/view-die-quotation-list/:id"
          element={<ViewDieQuotationList />}
        />
        <Route
          path="/view-work-order-list/:id"
          element={<ViewWorkOrderList />}
        />
        <Route path="/view-proforma/:id" element={<ViewProforma />} />
        <Route path="/indent-status" element={<IndentStatus />} />
        <Route
          path="/work-order-date-wise"
          element={<WorkOrderDateWiseReport />}
        />
        <Route path="/packing-report-list" element={<PackingReportList />} />
        <Route path="/packing-report" element={<PackingReport />} />
        <Route path="/dispatch-report" element={<DispatchReport />} />
        <Route path="/nalco" element={<Nalco />} />
        <Route path="/archive-nalco" element={<ArchiveNalco />} />
        <Route path="/activity-log-list" element={<ActivityList />} />
        {/* <Route path="/inquiry-form" element={<CustomerInquiryForm />} /> */}
        {/* Transporter Module */}

        <Route path="/transporter-list" element={<TransporterList />} />
        <Route path="/archive-transporter" element={<ArchiveTransporter />} />
        <Route path="/add-transporter" element={<AddTransporter />} />
        <Route path="/edit-transporter/:id" element={<EditTransporter />} />
        <Route path="/vehicle-type-list" element={<VehicleTypeList />} />
        <Route
          path="/archive-vehicle-type-list"
          element={<ArchiveVehicleTypeList />}
        />
        <Route path="/material-list" element={<MaterialList />} />
        <Route
          path="/archive-material-list"
          element={<ArchiveMaterialList />}
        />
        <Route path="/vehicle-list" element={<VehicleList />} />
        <Route
          path="/archive-vehicle-list"
          element={<ArchiveVehicleList />}
        />

        {/*First Weight Module*/}
        <Route path="/first-weight-entry-list" element={<FirstWeightEntryList />} />
        <Route path="/archive-first-weight-entry" element={<ArchiveFirstWeightEntry />} />
        <Route path="/add-first-weight-entry" element={<AddFirstWeightEntry />} />
        <Route path="/edit-first-weight-entry/:id" element={<EditFirstWeightEntry />} />
        {/*Second Weight Module*/}
        <Route path="/second-weight-entry-list" element={<SecondWeightEntryList />} />
        <Route path="/archive-second-weight-entry" element={<ArchiveSecondWeightEntry />} />
        <Route path="/add-second-weight-entry" element={<AddSecondWeightEntry />} />
        <Route path="/edit-second-weight-entry/:id" element={<EditSecondWeightEntry />} />

        {/*Manual Weight Entry Module*/}
        <Route path="/manual-weight-entry-list" element={<ManualWeightEntryList />} />
        <Route path="/archive-manual-weight-entry" element={<ArchiveManualWeightEntry />} />
        <Route path="/add-manual-weight-entry" element={<AddManualWeightEntry />} />
        <Route path="/edit-manual-weight-entry/:id" element={<EditManualWeightEntry />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default Root;
